import {CivilStatus} from '../dropdown-options';
import {Province} from '../province';
import {ReplaceInsurance} from './current-life-insurance';
import {FnaAgent} from './fna-agent';

export const BASE_FUNERAL_COST = 10_000;

export interface Fna {
  id?: string;
  userId?: string;
  civilStatus?: CivilStatus;
  numChildren?: number;
  youngestChildAgeInMonths?: number;
  job?: string;
  salary?: number;
  mortgageAmount?: number;
  debtAmount?: number;
  savingsAmount?: number;
  heritageAmount?: number;
  province?: Province;
  monthlyDebtPaymentAmount?: number;
  funeralCost?: number;

  hasLifeInsurance?: boolean;
  currentProtections?: CurrentProtection[];
  agents?: FnaAgent[];

  readonly withHumanAgent?: boolean;
  readonly isComplete?: boolean;
  readonly salaryReplacement?: number;
  readonly permanentNeeds?: number;
  readonly recommendationPermanentNeeds?: number;
  readonly temporaryNeeds?: number;
  readonly recommendationTemporaryNeeds?: number;
  readonly temporaryNeedsDuration?: number;
  readonly cancerNeeds?: number;
  readonly disabilityNeeds?: number;
  readonly needs?: number;
  readonly recommendationNeeds?: number;
}

export interface CurrentProtection {
  coverageAmount?: number;
  coverageType?: string;
  issueDate?: Date;
  issuerName?: string;
  isReplacing?: ReplaceInsurance;
  policyNumber?: string;
}
